module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAeUExURba2trq6ukdwTLu7u7a2trW1tbq6ure3t729vbW1tYRObCsAAAAGdFJOU5sGAAteXavwpsMAAABwSURBVCjPhZLBAsAQDEPTFuX/f3jmMHGIOWkfabTgYsHdSpy5KPaCQIdx3tARE9SejYmhZa/rRhtEbIWxajD5AvhB9hZHSEfAAiwKluZiIDOZZA/bZo6R2/YvUFKquLKrHqhaopoo234ZlBit/AxiPRQhBgnM8yPPAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/btn-close.png
// module id = gp6L
// module chunks = 12